import React, { Fragment, PureComponent } from 'react';
import { func } from 'prop-types';
import InsuranceCard from './InsuranceCard';
import { IMAGE_TYPE_FRONT, IMAGE_TYPE_BACK } from '../../constants/index';
import InsuranceCardShape from '../../shapes/InsuranceCard';

export default class InsuranceUploader extends PureComponent {
  static propTypes = {
    insuranceCard: InsuranceCardShape,
    onClickFront: func,
    onClickBack: func,
    handleFileChange: func,
  };

  static defaultProps = {
    insuranceCard: {
      front: {},
      back: {},
    },
  };

  state = {
    showTakeTooLong: false,
  };

  render = () => {
    const { insuranceCard, onClickBack, onClickFront, handleFileChange } = this.props;

    return (
      <Fragment>
        <InsuranceCard
          cardImage={insuranceCard.front.base64}
          onClick={onClickFront}
          scanStarted={insuranceCard.front.scanStarted}
          scanCompleted={insuranceCard.front.scanCompleted}
          handleFileChange={handleFileChange(IMAGE_TYPE_FRONT)}
          showPlaceholder
        >
          Scan front of card
        </InsuranceCard>
        <InsuranceCard
          cardImage={insuranceCard.back.base64}
          showPlaceholder={!!insuranceCard.front.base64}
          onClick={onClickBack}
          scanStarted={insuranceCard.back.scanStarted}
          scanCompleted={insuranceCard.back.scanCompleted}
          handleFileChange={handleFileChange(IMAGE_TYPE_BACK)}
        >
          Scan back of card
        </InsuranceCard>
      </Fragment>
    );
  };
}
